import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

// Gates the Cart Assistant cold-start prompt-starters editor. This is a write-only surface — Save
// creates/updates/publishes a store-config draft — so it requires the store-config *modify* permission
// (not just view) for real runtime enforcement. The same config backs both the route and its nav
// entry, so view-only users neither see the entry nor can reach the write flow. The feature toggle
// keeps the tool hidden until the Roulette flag `rt_cart_assistant_prompt_starters` is created and
// ramped (follow-up), so the tool ships dark until the backend write path is ready.
export const cartAssistantEditorAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.StoreConfigsModify],
  featureToggles: [FeatureToggle.cartAssistantPromptStarters],
  restrictedBannersAllowed: true,
}
